let infiniteScrollObserver = null;
let infiniteScrollSentinel = null;
let infiniteScrollLoading = false;
let infiniteScrollFallbackListening = false;
let infiniteScrollFallbackTimer = 0;
let infiniteScrollFallbackLast = 0;

const INFINITE_SCROLL_MARGIN_PX = 600;
const INFINITE_SCROLL_THROTTLE_MS = 100;

const loadItems = (button) => {
  if (infiniteScrollLoading || !button || button.isConnected === false) return;

  const totalPages = parseInt($('[data-total-pages]').val());
  let currentPage = parseInt($('[data-current-page]').val());
  let currentPageScroll = currentPage + 1;

  currentPage = currentPage + 1;
  const nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/, 'page=' + currentPage);
  const nextUrlScroll = $('[data-next-url]').val().replace(/page=[0-9]+/, 'page=' + currentPageScroll);
  $('[data-current-page]').val(currentPage);

  infiniteScrollLoading = true;
  button.setAttribute('disabled', '');
  button.classList.add('loading');

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function (responseHTML) {
      $('.load-more-grid').append($(responseHTML).find('.load-more-grid').html());
      colorSwatches();
    },
    complete: function () {
      infiniteScrollLoading = false;

      if (currentPage <= totalPages) {
        const scollData = document.querySelector('.infinite-scroll__data');
        if (scollData && currentPage != totalPages) {
          scollData.querySelector('input[data-next-url]').dataset.nextUrl = nextUrlScroll;
          scollData.querySelector('input[data-next-url]').value = nextUrlScroll;
          scollData.querySelector('input[data-current-page]').dataset.currentPage = currentPage;
          scollData.querySelector('input[data-current-page]').value = currentPage;
          checkVisibility();
        }
        button.removeAttribute('disabled');
        button.classList.remove('loading');
        if (currentPage == totalPages) {
          stopInfiniteScroll();
          button.remove();
        }
      }
    }
  });
};

const onInfiniteScrollIntersect = (entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      loadItems(entry.target);
    }
  });
};

const armInfiniteScroll = (sentinel) => {
  if (!sentinel) return;
  if (infiniteScrollObserver && infiniteScrollSentinel === sentinel) return;

  if (infiniteScrollObserver && infiniteScrollSentinel && infiniteScrollSentinel !== sentinel) {
    infiniteScrollObserver.unobserve(infiniteScrollSentinel);
    infiniteScrollObserver.observe(sentinel);
    infiniteScrollSentinel = sentinel;
    return;
  }

  if (infiniteScrollObserver) {
    infiniteScrollObserver.disconnect();
    infiniteScrollObserver = null;
  }

  infiniteScrollObserver = new IntersectionObserver(onInfiniteScrollIntersect, {
    root: null,
    rootMargin: '600px 0px',
    threshold: 0
  });
  infiniteScrollObserver.observe(sentinel);
  infiniteScrollSentinel = sentinel;
};

const runInfiniteScrollFallback = () => {
  const sentinel = document.querySelector('.js-infinite-scroll');
  if (!sentinel) {
    removeInfiniteScrollFallback();
    return;
  }

  const viewportBottom = window.innerHeight || document.documentElement.clientHeight;
  if (sentinel.getBoundingClientRect().top <= viewportBottom + INFINITE_SCROLL_MARGIN_PX) {
    loadItems(sentinel);
  }
};

const onInfiniteScrollFallback = () => {
  const now = Date.now();
  const remaining = INFINITE_SCROLL_THROTTLE_MS - (now - infiniteScrollFallbackLast);

  if (remaining <= 0) {
    infiniteScrollFallbackLast = now;
    if (infiniteScrollFallbackTimer) {
      window.clearTimeout(infiniteScrollFallbackTimer);
      infiniteScrollFallbackTimer = 0;
    }
    runInfiniteScrollFallback();
    return;
  }

  if (infiniteScrollFallbackTimer) return;

  infiniteScrollFallbackTimer = window.setTimeout(() => {
    infiniteScrollFallbackTimer = 0;
    infiniteScrollFallbackLast = Date.now();
    if (!infiniteScrollFallbackListening) return;
    runInfiniteScrollFallback();
  }, remaining);
};

const removeInfiniteScrollFallback = () => {
  if (infiniteScrollFallbackTimer) {
    window.clearTimeout(infiniteScrollFallbackTimer);
    infiniteScrollFallbackTimer = 0;
  }
  if (!infiniteScrollFallbackListening) return;
  window.removeEventListener('scroll', onInfiniteScrollFallback);
  window.removeEventListener('resize', onInfiniteScrollFallback);
  infiniteScrollFallbackListening = false;
};

const addInfiniteScrollFallback = () => {
  if (infiniteScrollFallbackListening) return;
  window.addEventListener('scroll', onInfiniteScrollFallback, { passive: true });
  window.addEventListener('resize', onInfiniteScrollFallback);
  infiniteScrollFallbackListening = true;
};

const stopInfiniteScroll = () => {
  if (infiniteScrollObserver) {
    infiniteScrollObserver.disconnect();
    infiniteScrollObserver = null;
  }
  infiniteScrollSentinel = null;
  removeInfiniteScrollFallback();
};

const checkVisibility = () => {
  const sentinel = document.querySelector('.js-infinite-scroll');
  if (!sentinel) {
    stopInfiniteScroll();
    return;
  }

  armInfiniteScroll(sentinel);
  addInfiniteScrollFallback();
};

function loadMore() {
  document.querySelectorAll('.js-load-more').forEach((button) => {
    button.onclick = () => {
      loadItems(button);
    };
  });

  checkVisibility();
}

(function () {
  loadMore();
})();
